import React from 'react';
import './StaffListStyles.css';

const staffMembers = [
    {
        name: 'Pastor Aaron Goeke',
        image: 'pastor.jpg'
    },
    {
        name: 'President Greg Waltz',
        image: 'president.jpg'
    },
    {
        name: 'Vice-President Larry Coyle',
        image: 'vice-president.jpg'
    },
    {
        name: 'Secretary Vicki Lewis',
        image: 'secretary.jpg'
    },
    {
        name: 'Treasurer Kevin Schnitzer',
        image: 'treasurer.jpg'
    },
    {
        name: 'At-Large Farrah Schueling',
        image: 'at-large-1.jpg'
    },
    {
        name: 'At-Large Scott Conrad',
        image: 'at-large-2.jpg'
    }
];

const StaffList = () => {
    return (
        <div className='staff-list'>
            {staffMembers.map((member, index) => (
                <div key={index} className='staff-member'>
                    <img src={member.image} alt={member.name}/>
                    <span style={{color: 'white'}}>{member.name}</span>
                </div>
            ))};
        </div>
    );
};

export default StaffList;
